import InstructorView from "./InstructorView"
import StudentView from "./StudentView"

export default function OfficeHoursTab({ courseId, isInstructor }) {
  return (
    <section>
      {isInstructor
        ? <InstructorView courseId={courseId} />
        : <StudentView courseId={courseId} />
      }
    </section>
  )
}
